jQuery(document).ready(function ($) {
  $('#engagebay-form').on('submit', function (event) {
    event.preventDefault() // Zapobiega domyślnemu wysłaniu formularza

    // Pobierz dane z formularza
    var formData = {
      name: $('#name').val(),
      email: $('#email').val(),
    }

    // Wyślij żądanie AJAX
    $.ajax({
      type: 'POST',
      url: themeData.ajax_url, //Używamy zmiennej przekazanej przez PHP
      data: {
        action: 'add_engagebay_contact_ajax', // Nazwa akcji (będzie użyta w PHP)
        form_data: formData, // Dane formularza
      },
      dataType: 'json', // Oczekujemy odpowiedzi w formacie JSON
      beforeSend: function () {
        // Możesz tutaj dodać np. animację ładowania
        $('#message-container').html('<p>Processing...</p>')
      },
      success: function (response) {
        console.log('RESRPONSE ->', response)
        // Obsługa odpowiedzi (sukces)
        if (response.success) {
          $('#message-container').html(
            '<p class="success">' + response.data.message + '</p>'
          )
          setTimeout(function () {
            $('#message-container').html('')
          }, 4000)

          $('#engagebay-form')[0].reset()
        } else {
          $('#message-container').html(
            '<p class="error">' + response.data.message + '</p>'
          )
          setTimeout(function () {
            $('#message-container').html('')
          }, 3000)
          $('#engagebay-form')[0].reset()
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        //Obsługa błedów AJAX, np. błąd połączenia
        $('#message-container').html(
          '<p class="error">Błąd AJAX: ' +
            textStatus +
            ' - ' +
            errorThrown +
            '</p>'
        )
        console.log(jqXHR, textStatus, errorThrown) //Wypisz szczegóły do konsoli
      },
    })
  })
})
